import { render } from "./HormoneZoomerView.vue?vue&type=template&id=c2fff978&scoped=true"
import script from "./HormoneZoomerView.vue?vue&type=script&lang=js"
export * from "./HormoneZoomerView.vue?vue&type=script&lang=js"

import "./HormoneZoomerView.vue?vue&type=style&index=0&id=c2fff978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2fff978"]])

export default __exports__